import { render, staticRenderFns } from "./visibleHeader.vue?vue&type=template&id=b2b73c66&scoped=true"
import script from "./visibleHeader.ts?vue&type=script&lang=ts&external"
export * from "./visibleHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b73c66",
  null
  
)

export default component.exports